module.exports = __webpack_public_path__ + "static/img/ding-a.e04a0bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ding-a.png
// module id = K3+Z
// module chunks = 1